import enums from '@/enums';

export default [
  {
    url: '/home',
    name: 'Home',
    icon: 'HomeIcon',
    i18n: '$General.Home',
    slug: 'home',
  },
  {
    url: null,
    name: 'Analytics',
    icon: 'BarChart2Icon',
    i18n: '$General.Analytics',
    slug: 'analytics',
    submenu: [
      {
        url: '/analytics/campaigns',
        name: 'Campaign analytics',
        icon: 'MessageCircleIcon',
        i18n: '$General.Campaign',
        slug: 'campaigns-analytics',
      },
      {
        url: '/analytics/contacts',
        name: 'Contact analytics',
        icon: 'BookIcon',
        i18n: '$Entities.Contact',
        slug: 'contacts-analytics',
      },
      {
        url: '/analytics/reviews',
        name: 'Review analytics',
        icon: 'StarIcon',
        i18n: '$General.Review',
        slug: 'reviews-analytics',
      },
      {
        url: '/analytics/feedback',
        name: 'Feedback analytics',
        icon: 'ActivityIcon',
        i18n: '$General.Feedback',
        slug: 'feedback-analytics',
        roles: [enums.Auth.Role.ADMIN],
      },
    ],
  },
  {
    header: 'Tools',
    i18n: '$General.Tools',
    items: [
      {
        name: 'Messaging',
        icon: 'MessageSquareIcon',
        i18n: '$General.Messaging',
        slug: 'messaging',
        submenu: [
          {
            url: '/sms/campaigns/create',
            name: 'SMS Campaign Create',
            icon: 'MessageCircleIcon',
            i18n: '$Entities.SMSCampaign',
            i18nCount: 1,
            slug: 'sms-campaigns-create',
          },
          {
            url: '/sms/campaigns/quick',
            name: 'SMS Campaign Quick',
            icon: 'SendIcon',
            i18n: '$General.QuickSMS',
            slug: 'sms-campaigns-quick',
          },
          {
            url: '/sms/campaigns',
            name: 'SMS Campaigns History',
            icon: 'ListIcon',
            i18n: '$General.History',
            i18nCount: 1,
            slug: 'sms-campaigns-history',
          },
          {
            url: '/sms/campaigns/scheduled',
            name: 'SMS Campaigns Scheduled',
            icon: 'ClockIcon',
            i18n: '$General.Scheduled',
            i18nCount: 1,
            slug: 'sms-campaigns-scheduled',
          },
          {
            url: '/sms/campaigns/drafts',
            name: 'SMS Campaigns Drafts',
            icon: 'EditIcon',
            i18n: '$General.Draft',
            i18nCount: 2,
            slug: 'sms-campaigns-drafts',
          },
          {
            url: '/sms/inbox',
            name: 'SMSInbounds',
            icon: 'InboxIcon',
            i18n: '$Entities.SMSInbound',
            slug: 'sms-inbounds',
          },
          {
            url: '/sms/templates',
            name: 'SMSTemplates',
            icon: 'LayoutIcon',
            i18n: '$General.Template',
            i18nCount: 2,
            slug: 'sms-templates',
          },
        ],
      },
      {
        url: '/reviews',
        name: 'Reviews',
        icon: 'StarIcon',
        i18n: '$General.Review',
        slug: 'reviews',
      },
      {
        url: '/waitlist',
        name: 'Waitlist',
        icon: 'UsersIcon',
        i18n: '$General.WaitingList',
        slug: 'waitlist',
      },
      {
        url: null,
        name: 'Perks',
        icon: 'GiftIcon',
        i18n: '$General.Perks',
        slug: 'perks',
        isDisabled: true,
      },
    ],
  },
  {
    header: 'Contacts',
    icon: 'BookIcon',
    i18n: '$Entities.Contact',
    slug: 'contacts',
    items: [
      {
        url: '/contacts',
        name: 'Contact List',
        icon: 'ListIcon',
        i18n: '$NavMenu.ContactList',
        slug: 'contacts',
      },
      {
        url: '/contacts/segments',
        name: 'Segments',
        icon: 'FilterIcon',
        i18n: '$Entities.Segment',
        slug: 'segments',
      },
      {
        url: '/contacts/tags',
        name: 'Tags',
        icon: 'TagIcon',
        i18n: '$Entities.Tag',
        slug: 'tags',
      },
      {
        url: '/contacts/attributes',
        name: 'ContactAttributes',
        icon: 'CheckCircleIcon',
        i18n: '$Entities.ContactAttribute',
        slug: 'custom-fields',
      },
    ],
  },
  {
    header: 'Help',
    icon: 'HelpCircleIcon',
    i18n: '$General.Help',
    items: [
      {
        url: '/faqs',
        slug: 'faq',
        name: 'FAQs',
        icon: 'HelpCircleIcon',
        i18n: '$General.FAQ',
      },
      {
        url: '/documentation',
        slug: 'documentation',
        name: 'Documentation',
        icon: 'BookOpenIcon',
        i18n: '$General.Documentation',
      },
    ],
  },
  {
    header: 'divider',
    divider: true,
    items: [],
  },
  {
    url: '/settings',
    name: 'Settings',
    icon: 'SettingsIcon',
    i18n: '$General.Setting',
    slug: 'user-settings',
  },
  {
    url: null,
    name: 'Bin',
    icon: 'TrashIcon',
    i18n: '$General.Trash',
    slug: 'trash',
    submenu: [
      {
        url: '/trash/contacts',
        name: 'Contacts',
        icon: 'BookIcon',
        i18n: '$Entities.Contact',
        slug: 'contacts-trash',
      },
      {
        url: '/trash/sms-templates',
        name: 'SMS templates',
        icon: 'MessageSquareIcon',
        i18n: '$Entities.SMSTemplate',
        slug: 'sms-templates-trash',
      },
    ],
  },
  {
    url: null,
    name: 'Log out',
    icon: 'LogOutIcon',
    i18n: '$General.Logout',
    slug: 'logout',
    class: 'mt-auto',
  },
];
